const { createClientModuleProxy } = require("react-server-dom-turbopack/server.edge");

__turbopack_context__.n(createClientModuleProxy("[project]/node_modules/next/dist/esm/client/components/error-boundary.js <module evaluation>"));
